import React, { useRef } from 'react';
import * as S from './styles';
import Events from '../../Events';
function Home1() {
  const divRef = useRef<HTMLDivElement | null>(null); // Especificando que o ref pode ser de um HTMLDivElement ou null

  const scrollToDiv = () => {
    divRef.current && divRef.current.scrollIntoView({ behavior: 'smooth' }); // Scroll suave até a div
  };
  return (
    <S.Main>
      <S.Section>
        <S.TextDiv>
          <div>
            <h4>PERCURSOS EM PSICANÁLISE</h4>
            <h3>Conectar saberes e transformar trajetórias</h3>
          </div>
          <p>
            Desde 2017, somos uma rede coletiva para formação contínua de
            psicanalistas. <br />
            Junte-se a nós e descubra encontros que inspiram e fortalecem.
          </p>
          <button onClick={scrollToDiv}>Quem somos</button>{' '}
        </S.TextDiv>
      </S.Section>
      <div ref={divRef} />
    </S.Main>
  );
}

export default Home1;
